import { cn } from "@/lib/utils";

const ErrorMessage = ({
	content,
	className,
}: {
	content?: React.ReactNode;
	className?: string;
}) => {
	return (
		<div className={cn("text-sm text-red-500", className)}>{content || "something went wrong"}</div>
	);
};

export default ErrorMessage;
